<template>
  <base-item-group :item="item" sub-group />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ItemSubGroup',

  props: {
    item: {
      type: Object,
      default: () => ({
        avatar: undefined,
        group: undefined,
        title: undefined,
        children: [],
      }),
    },
  },
})
</script>
<style lang="scss">
.v-list-group--subgroup {
  .v-list-item {
    padding-left: 20px !important;
  }
}
</style>
